export function PrivacyPolicyContent() {
  return (
    <>
      <header>
        <h1 id="privacy-heading">Datenschutzerklärung</h1>
        <p>RiviDent-Patientenportal</p>
        <p>Stand: <mark className="privacy-page__placeholder">[Datum der Veröffentlichung]</mark></p>
        <p>Der Schutz Ihrer persönlichen Daten und insbesondere Ihrer Gesundheitsinformationen ist uns wichtig.</p>
        <p>Das RiviDent-Patientenportal ermöglicht Ihnen einen digitalen Zugang zu ausgewählten Dienstleistungen und Informationen Ihrer Zahnarztpraxis. Dazu gehören je nach Funktionsumfang beispielsweise die Verwaltung von Terminen, der Zugriff auf Dokumente und die Kommunikation mit Ihrer Praxis.</p>
        <p>In dieser Datenschutzerklärung informieren wir Sie darüber, wer Ihre Personendaten bearbeitet, welche Daten verarbeitet werden, zu welchen Zwecken dies geschieht und welche Rechte Sie haben.</p>
      </header>
      <section>
        <h2>1. Wer ist für die Bearbeitung Ihrer Daten verantwortlich?</h2>
        <p>Für die Bearbeitung Ihrer medizinischen Patientendaten ist grundsätzlich Ihre behandelnde Zahnarztpraxis verantwortlich.</p>
        <h3>Verantwortliche Zahnarztpraxis</h3>
        <p>
          <mark className="privacy-page__placeholder">[Name der Zahnarztpraxis]</mark>
          <br />
          <mark className="privacy-page__placeholder">[Adresse]</mark>
          <br />
          <mark className="privacy-page__placeholder">[Telefonnummer]</mark>
          <br />
          <mark className="privacy-page__placeholder">[E-Mail-Adresse]</mark>
        </p>
        <h3>Technischer Anbieter des Patientenportals</h3>
        <p>
          RiviDent
          <br />
          <mark className="privacy-page__placeholder">[Vollständige rechtliche Firmenbezeichnung]</mark>
          <br />
          <mark className="privacy-page__placeholder">[Geschäftsadresse]</mark>
          <br />
          <mark className="privacy-page__placeholder">[Kontaktadresse]</mark>
        </p>
        <p>RiviDent stellt die technische Plattform zur Verfügung und unterstützt die Zahnarztpraxis bei der digitalen Bereitstellung und Verwaltung ausgewählter Patienteninformationen.</p>
        <p>Soweit RiviDent Personendaten im Auftrag der Zahnarztpraxis bearbeitet, erfolgt dies auf Grundlage entsprechender vertraglicher Vereinbarungen.</p>
        <p>Für bestimmte eigene Bearbeitungen, beispielsweise im Zusammenhang mit dem technischen Betrieb oder der eigenen Kundenverwaltung, kann RiviDent selbst datenschutzrechtlich verantwortlich sein. Die konkrete Zuständigkeit richtet sich nach der jeweiligen Datenbearbeitung.</p>
        <p>Bei Fragen zu Ihren medizinischen Patientendaten wenden Sie sich bitte in erster Linie an Ihre behandelnde Zahnarztpraxis.</p>
      </section>
      <section>
        <h2>2. Welche Personendaten werden verarbeitet?</h2>
        <p>Im Zusammenhang mit dem Patientenportal können insbesondere folgende Daten verarbeitet werden:</p>
        <h3>2.1 Persönliche und administrative Daten</h3>
        <ul>
          <li>Vorname und Nachname</li>
          <li>Geburtsdatum</li>
          <li>Adresse und Kontaktdaten</li>
          <li>Angaben zur Patientenidentifikation</li>
          <li>Informationen über vereinbarte Behandlungstermine</li>
          <li>Rechnungs- und Zahlungsinformationen</li>
          <li>Weitere für die Nutzung des Portals erforderliche administrative Angaben</li>
        </ul>
        <h3>2.2 Medizinische Daten</h3>
        <p>Soweit diese Funktionen von Ihrer Zahnarztpraxis bereitgestellt werden, können im Patientenportal auch medizinische Informationen zugänglich sein, insbesondere:</p>
        <ul>
          <li>Zahnmedizinische Befunde und Behandlungsinformationen</li>
          <li>Behandlungspläne und Kostenvoranschläge</li>
          <li>Röntgenbilder und weitere medizinische Dokumente</li>
          <li>Informationen zu bevorstehenden und abgeschlossenen Behandlungen</li>
          <li>Hinweise zur Vorbereitung und Nachsorge</li>
        </ul>
        <p>Gesundheitsdaten gehören zu den besonders schützenswerten Personendaten und unterliegen erhöhten gesetzlichen Schutzanforderungen.</p>
        <h3>2.3 Kommunikation</h3>
        <p>Bei der Nutzung der Kommunikationsfunktionen können Nachrichten zwischen Ihnen und Ihrer Zahnarztpraxis sowie damit verbundene Angaben verarbeitet werden.</p>
        <p>Dies kann beispielsweise Terminanfragen, Terminänderungen, behandlungsbezogene Mitteilungen oder Hinweise zur Nachsorge betreffen.</p>
        <h3>2.4 Technische Nutzungsdaten</h3>
        <p>Beim Zugriff auf das Patientenportal können technische Informationen verarbeitet werden, die für den Betrieb und die Sicherheit erforderlich sind.</p>
        <p>Dazu können beispielsweise gehören:</p>
        <ul>
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit des Zugriffs</li>
          <li>Browser- und Geräteinformationen</li>
          <li>Informationen zur Anmeldung und Authentifizierung</li>
          <li>Sicherheits- und Zugriffsprotokolle</li>
        </ul>
        <p>Passwörter und andere Authentifizierungsdaten sind durch angemessene technische und organisatorische Massnahmen zu schützen.</p>
      </section>
      <section>
        <h2>3. Wofür bearbeiten wir Ihre Personendaten?</h2>
        <p>Ihre Daten werden im Rahmen der jeweiligen Zuständigkeiten insbesondere zu folgenden Zwecken verarbeitet:</p>
        <h3>Bereitstellung des Patientenportals</h3>
        <p>Um Ihnen den sicheren Zugang zu Ihrem persönlichen Patientenbereich zu ermöglichen.</p>
        <h3>Terminverwaltung</h3>
        <p>Um Termine einzusehen, zu vereinbaren, zu verschieben oder entsprechende Informationen Ihrer Zahnarztpraxis zu erhalten.</p>
        <h3>Bereitstellung medizinischer Dokumente</h3>
        <p>Um Ihnen ausgewählte Unterlagen Ihrer zahnmedizinischen Behandlung digital zugänglich zu machen.</p>
        <h3>Patientenkommunikation</h3>
        <p>Um den sicheren Austausch von Informationen und Nachrichten zwischen Ihnen und Ihrer Zahnarztpraxis zu unterstützen.</p>
        <h3>Vorbereitung und Nachsorge</h3>
        <p>Um Ihnen relevante Informationen vor oder nach einer zahnmedizinischen Behandlung bereitzustellen.</p>
        <h3>Administrative Abwicklung</h3>
        <p>Um Ihnen beispielsweise Rechnungen, Kostenvoranschläge oder weitere praxisbezogene Dokumente zur Verfügung zu stellen.</p>
        <h3>Sicherheit und technischer Betrieb</h3>
        <p>Um die Funktionsfähigkeit des Portals sicherzustellen, unberechtigte Zugriffe zu verhindern und technische Störungen zu erkennen.</p>
        <p>Die Bearbeitung erfolgt im Rahmen der jeweils anwendbaren gesetzlichen Bestimmungen und, soweit erforderlich, auf Grundlage einer entsprechenden Einwilligung oder einer anderen zulässigen Grundlage.</p>
      </section>
      <section>
        <h2>4. Wem werden Personendaten bekannt gegeben?</h2>
        <h3>4.1 Zahnarztpraxis und berechtigtes Praxispersonal</h3>
        <p>Ihre Daten können von den Mitarbeitenden Ihrer Zahnarztpraxis eingesehen und bearbeitet werden, soweit dies für ihre jeweiligen Aufgaben erforderlich und rechtlich zulässig ist.</p>
        <h3>4.2 Technische Dienstleister</h3>
        <p>Für die Bereitstellung und den sicheren Betrieb des Patientenportals können geeignete technische Dienstleister eingesetzt werden.</p>
        <p>Dazu können beispielsweise Anbieter für Hosting, IT-Betrieb, Authentifizierung oder Nachrichtenübermittlung gehören.</p>
        <p>Solche Dienstleister dürfen Personendaten nur im Rahmen ihrer zulässigen Aufgaben und unter den erforderlichen vertraglichen und gesetzlichen Schutzvorkehrungen bearbeiten.</p>
        <h3>4.3 Weitere Empfänger</h3>
        <p>Eine Bekanntgabe an weitere Empfänger erfolgt nur, soweit sie rechtlich zulässig oder erforderlich ist, beispielsweise aufgrund einer gesetzlichen Verpflichtung oder einer gültigen Einwilligung.</p>
        <p>Das zahnmedizinische Berufsgeheimnis sowie die anwendbaren Datenschutzbestimmungen sind dabei zu beachten.</p>
        <h3>4.4 Bearbeitung im Ausland</h3>
        <p><mark className="privacy-page__placeholder">[Hier sind die tatsächlichen Bearbeitungs- und Speicherorte sowie allfällige Auslandbekanntgaben, betroffene Staaten und erforderliche Datenschutzgarantien zu ergänzen.]</mark></p>
      </section>
      <section>
        <h2>5. Wie werden Ihre Daten geschützt und wie lange werden sie gespeichert?</h2>
        <h3>5.1 Datensicherheit</h3>
        <p>Zum Schutz Ihrer Daten werden technische und organisatorische Sicherheitsmassnahmen eingesetzt, die auf die Art der bearbeiteten Informationen und die damit verbundenen Risiken abgestimmt sein müssen.</p>
        <p>Dazu gehören je nach technischer Umsetzung insbesondere Massnahmen zur Zugriffssteuerung, sicheren Datenübertragung, Authentifizierung und Protokollierung.</p>
        <p><mark className="privacy-page__placeholder">[Hier sind die tatsächlich implementierten Sicherheitsmassnahmen zu ergänzen.]</mark></p>
        <h3>5.2 Speicherung</h3>
        <p>Das Patientenportal kann Informationen aus der Praxissoftware bereitstellen und, soweit technisch erforderlich und vorgesehen, bestimmte Daten selbst verarbeiten oder zwischenspeichern.</p>
        <p><mark className="privacy-page__placeholder">[Vor Veröffentlichung ist hier verbindlich festzuhalten, welche Daten in welchen Systemen gespeichert werden und welche Dienstleister daran beteiligt sind.]</mark></p>
        <h3>5.3 Aufbewahrungsdauer</h3>
        <p>Medizinische Behandlungsunterlagen unterliegen gesetzlichen Aufbewahrungspflichten. Die zuständige Zahnarztpraxis bewahrt diese entsprechend den jeweils anwendbaren Vorschriften auf.</p>
        <p>Daten, die ausschliesslich für den technischen Betrieb des Portals benötigt werden, werden grundsätzlich nur so lange aufbewahrt, wie es für die jeweiligen Zwecke erforderlich ist oder gesetzliche Pflichten dies verlangen.</p>
        <p>Die konkreten Aufbewahrungs- und Löschfristen richten sich nach der jeweiligen Datenkategorie und müssen anhand der tatsächlichen technischen Umsetzung festgelegt werden.</p>
        <h3>5.4 Beendigung der Portalnutzung</h3>
        <p>Die Beendigung eines Portalzugangs führt nicht automatisch zur Löschung der medizinischen Behandlungsdokumentation bei Ihrer Zahnarztpraxis.</p>
        <p>Gesetzliche Aufbewahrungspflichten bleiben bestehen.</p>
      </section>
      <section>
        <h2>6. Welche Rechte haben Sie?</h2>
        <p>Im Rahmen des anwendbaren Datenschutzrechts stehen Ihnen insbesondere folgende Rechte zu:</p>
        <h3>Auskunft</h3>
        <p>Sie können Auskunft darüber verlangen, ob und welche Personendaten über Sie bearbeitet werden.</p>
        <h3>Berichtigung</h3>
        <p>Sie können verlangen, dass unrichtige Personendaten berichtigt werden.</p>
        <h3>Herausgabe oder Übertragung</h3>
        <p>Unter den gesetzlichen Voraussetzungen können Sie die Herausgabe bestimmter Personendaten beziehungsweise deren Übertragung verlangen.</p>
        <h3>Löschung oder Einschränkung der Bearbeitung</h3>
        <p>Unter den gesetzlichen Voraussetzungen können Sie verlangen, dass eine unzulässige Datenbearbeitung unterlassen oder betreffende Daten gelöscht werden.</p>
        <p>Gesetzliche Aufbewahrungspflichten, insbesondere für medizinische Behandlungsunterlagen, bleiben vorbehalten.</p>
        <h3>Kontakt</h3>
        <p>Für Anliegen zu Ihren medizinischen Patientendaten wenden Sie sich bitte an Ihre behandelnde Zahnarztpraxis.</p>
        <p>Für Datenschutzfragen, die RiviDent als technischen Anbieter betreffen, erreichen Sie uns unter:</p>
        <p><mark className="privacy-page__placeholder">[Datenschutz-Kontaktadresse RiviDent]</mark></p>
      </section>
      <section>
        <h2>7. Cookies und technische Funktionen</h2>
        <p>Das Patientenportal kann technisch notwendige Cookies oder vergleichbare Technologien verwenden, beispielsweise um eine sichere Anmeldung und die Verwaltung einer Sitzung zu ermöglichen.</p>
        <p><mark className="privacy-page__placeholder">[Die tatsächlich verwendeten Cookies, Speichertechnologien und allfälligen externen Dienste sind zu prüfen und hier entsprechend zu beschreiben.]</mark></p>
      </section>
      <section>
        <h2>8. Änderungen dieser Datenschutzerklärung</h2>
        <p>Diese Datenschutzerklärung kann angepasst werden, insbesondere wenn sich gesetzliche Anforderungen, technische Funktionen oder die Art der Datenbearbeitung ändern.</p>
        <p>Die jeweils aktuelle Version wird im Patientenportal zur Verfügung gestellt.</p>
        <p>Zuletzt aktualisiert: <mark className="privacy-page__placeholder">[Datum]</mark></p>
      </section>
    </>
  );
}
